
import getCurrentScriptSrc from './get-current-script-src'
import { getSettingsFromUrl } from './get-settings-from-url'
import { logger } from './logger'

export function loadSettingsFromScriptUrl<T> (settings?: T): T {
  const targetUrl = getCurrentScriptSrc()
  logger.debug('Loading settings from script URL')
  return getSettingsFromUrl(targetUrl, settings)
}
